// This file is auto generated by bin/create-constants.js
'use es6';

export default [
  'add',
  'advancedFilters',
  'aggregateDataSetField',
  'alignCenter',
  'alignJustify',
  'alignLeft',
  'alignRight',
  'anchor',
  'appointment',
  'approvals',
  'approveDraft',
  'archive',
  'artificialIntelligence',
  'artificialIntelligenceEnhanced',
  'attach',
  'audienceTargeting',
  'audioFile',
  'audioInputOutput',
  'backgroundColor',
  'bank',
  'blank',
  'block',
  'blockAlignmentBottom',
  'blockAlignmentCenter',
  'blockAlignmentLeft',
  'blockAlignmentMiddle',
  'blockAlignmentRight',
  'blockAlignmentTop',
  'blog',
  'bold',
  'book',
  'booleanDataType',
  'box',
  'breezeRegenerate',
  'breezeSend',
  'breezeSingleStar',
  'bubble',
  'bulb',
  'bulletCircle',
  'bulletDiamond',
  'bulletList',
  'bulletLowerAlpha',
  'bulletLowerGreek',
  'bulletLowerRoman',
  'bulletSquare',
  'bulletUpperAlpha',
  'bulletUpperRoman',
  'callTranscript',
  'calling',
  'callingHangup',
  'callingMade',
  'callingMissed',
  'callingVoicemail',
  'campaigns',
  'cap',
  'cart',
  'case',
  'certification',
  'chain',
  'chatspot',
  'circleFilled',
  'circleHollow',
  'clipboard',
  'closedCaptions',
  'coachingPlaylist',
  'code',
  'column',
  'comment-o',
  'comments',
  'comments-o',
  'companies',
  'conditional',
  'conditionalFormulaDataSetField',
  'contact',
  'contactDuplicate',
  'contactProperties',
  'contacts',
  'copy',
  'course',
  'creditCard',
  'crop',
  'cssFile',
  'ctas',
  'customHubl',
  'customModules',
  'customObject',
  'dashboards',
  'dataQuality',
  'dataSync',
  'dataSyncLeft',
  'dataSyncRight',
  'databases',
  'date',
  'dateDataType',
  'deals',
  'debug',
  'delay',
  'delete',
  'description',
  'desktop',
  'developerProjects',
  'diff',
  'divider',
  'documents',
  'down',
  'downCarat',
  'download',
  'dragAndDropLayout',
  'dragHandle',
  'dropbox',
  'duplicate',
  'dynamicFilter',
  'edit',
  'editColumns',
  'ellipses',
  'email',
  'emailOpen',
  'emailThreadedReplies',
  'embed',
  'emoji',
  'emojiFillHappy',
  'emojiFillNeutral',
  'emojiFillSad',
  'emojiLineNeutral',
  'emojiLineSad',
  'enlarge',
  'enrichment',
  'enroll',
  'enumerationDataType',
  'eraseStyles',
  'excelFile',
  'exclamation',
  'exitFullScreen',
  'expand',
  'external-link',
  'externalLink',
  'eye',
  'favorite',
  'favoriteHollow',
  'file',
  'filter',
  'first',
  'fixedLayout',
  'flexColumn',
  'folder',
  'folderOpen',
  'folderServerlessFunction',
  'folderServerlessFunctionOpen',
  'folderTheme',
  'folderThemeOpen',
  'fontFile',
  'footer',
  'forms',
  'formulaDataSetField',
  'forward',
  'fullWidth',
  'gauge',
  'gddc',
  'generateChart',
  'ghost',
  'gift',
  'github',
  'githubBranch',
  'githubCommit',
  'githubRepository',
  'globalGroup',
  'goal',
  'graphqlFile',
  'grid',
  'groupModule',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'header',
  'hide',
  'highlight',
  'highlyEngagedLead',
  'home',
  'horizontalRule',
  'hsDesignCert',
  'htmlFile',
  'hubDB',
  'hubspotCertification',
  'imageAlignmentLeft',
  'imageAlignmentMiddle',
  'imageAlignmentRight',
  'imageAlignmentTop',
  'imageGallery',
  'inbox',
  'indent',
  'info',
  'inline',
  'insertImage',
  'insertQuote',
  'insertVideo',
  'integrations',
  'integrationsSalesForce',
  'integrationsSurveyMonkey',
  'invoice',
  'italic',
  'jsFile',
  'jsonFile',
  'key',
  'knowledgeBase',
  'language',
  'last',
  'layers',
  'left',
  'lesson',
  'lineHeight',
  'link',
  'listView',
  'lists',
  'location',
  'locked',
  'logCall',
  'logEmail',
  'logLinkedInMessage',
  'logMeeting',
  'logPostalMail',
  'logSMS',
  'logWhatsAppMessage',
  'logo',
  'makeDraft',
  'markdownFile',
  'marketingEvents',
  'marketplace',
  'meetings',
  'mention',
  'menu',
  'merge',
  'messages',
  'minus',
  'mobile',
  'move',
  'next',
  'nonbreakingSpace',
  'notEditable',
  'notification',
  'notificationOff',
  'notificationPopup',
  'numberList',
  'numericDataType',
  'objectAssociations',
  'objectAssociationsManyToMany',
  'objectAssociationsManyToOne',
  'office365',
  'onlineRegistration',
  'order',
  'outdent',
  'paidAd',
  'paragraph',
  'partial',
  'paymentSubscriptions',
  'pdfFile',
  'pencil',
  'photo',
  'piesync',
  'pin',
  'playerFastForward',
  'playerPause',
  'playerPlay',
  'playerRewind',
  'popOut',
  'powerPointFile',
  'presentation',
  'previous',
  'product',
  'publish',
  'question',
  'questionAnswer',
  'quickbooks',
  'ratioDataSetField',
  'reCaptcha',
  'readMore',
  'readOnlyView',
  'realEstateListing',
  'recentlySelected',
  'record',
  'redo',
  'refresh',
  'registration',
  'remove',
  'removeTextStyle',
  'replace',
  'reply',
  'replyAll',
  'reportSpam',
  'reports',
  'requiredProperty',
  'richText',
  'right',
  'rotate',
  'rotateLeads',
  'row',
  'salesQuote',
  'salesTemplates',
  'saveEditableView',
  'search',
  'section',
  'sectionHeader',
  'seekBackward15',
  'seekBackward30',
  'seekForward15',
  'seekForward30',
  'send',
  'sequences',
  'serverlessFunction',
  'settings',
  'share',
  'sidebarCollapse',
  'sidebarExpand',
  'signature',
  'simpleBot',
  'siteTree',
  'sms',
  'social',
  'socialBlockFacebook',
  'socialBlockGoogleplus',
  'socialBlockInstagram',
  'socialBlockLink',
  'socialBlockLinkedin',
  'socialBlockPinterest',
  'socialBlockRss',
  'socialBlockTwitter',
  'socialBlockX',
  'socialBlockXing',
  'socialBlockYoutube',
  'socialBlockYoutubeplay',
  'socialFacebook',
  'socialFacebookMessenger',
  'socialFacebookWorkplace',
  'socialGoogle',
  'socialGoogleDrive',
  'socialGoogleplus',
  'socialHeart',
  'socialInstagram',
  'socialJira',
  'socialLinkedin',
  'socialMicrosoftTeams',
  'socialPinterest',
  'socialRetweet',
  'socialRss',
  'socialSlack',
  'socialTwitter',
  'socialWhatsapp',
  'socialX',
  'socialXing',
  'socialYoutube',
  'socialYoutubeplay',
  'sortAlpAsc',
  'sortAlpDesc',
  'sortAmtAsc',
  'sortAmtDesc',
  'sortNumAsc',
  'sortNumDesc',
  'sortTableAsc',
  'sortTableDesc',
  'spacer',
  'specialCharacter',
  'spellCheck',
  'splitModule',
  'sprocket',
  'stopRecord',
  'strike',
  'styles',
  'subscript',
  'success',
  'superscript',
  'switchDataSetField',
  'switcher',
  'table',
  'tablet',
  'tag',
  'tasks',
  'test',
  'text',
  'textColor',
  'textDataType',
  'textSnippet',
  'theme',
  'themeFile',
  'thumbsDown',
  'thumbsUp',
  'ticket',
  'time',
  'translate',
  'trophy',
  'twoFAFill',
  'twoFAOutline',
  'unarchive',
  'underline',
  'undo',
  'unlink',
  'unlocked',
  'unpublish',
  'up',
  'upCarat',
  'upgrade',
  'upload',
  'upload-light',
  'verticalMenu',
  'video',
  'videoFile',
  'videoPlayerSubtitles',
  'view',
  'viewDetails',
  'volume',
  'volumeDown',
  'volumeMute',
  'volumeUp',
  'wallet',
  'warning',
  'warning-triangle',
  'website',
  'wordFile',
  'workflows',
  'xmlFile',
  'zoomIn',
  'zoomOut',
];
